import styled from "styled-components";
import {TooltipContainerDefaultBox} from "./tooltip-container.default";

export const TooltipContainerMrGreenBox = styled(TooltipContainerDefaultBox)`
  background: ${({backgroundColor, theme}) => backgroundColor ? backgroundColor : theme.colors.backgroundContrast};
  box-shadow: none;
  border-color: ${({borderColor, theme}) => borderColor ? borderColor : theme.colors.brandPrimaryContrast};
`;